import { Controller } from "@hotwired/stimulus";

// SAL-048: the Board's masonry, as the prototype lays it out. The grid has
// 6px rows; each card spans as many as its height needs, measured here and
// again when the width, a font or an image changes it. Without JavaScript the
// Board stays a plain grid (the is-masonry class is only set here).
const ROW = 6;
const GAP = 16;

export default class extends Controller {
  connect() {
    this.layout = this.layout.bind(this);
    this.element.classList.add("is-masonry");
    this.observer = new ResizeObserver(() => this.schedule());
    this.observer.observe(this.element);
    [...this.element.children].forEach((card) => this.observer.observe(card));
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.schedule());
    this.element.addEventListener("load", this.layout, true);
    this.layout();
  }

  disconnect() {
    this.observer.disconnect();
    this.element.removeEventListener("load", this.layout, true);
    this.element.classList.remove("is-masonry");
  }

  schedule() {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = null;
      this.layout();
    });
  }

  layout() {
    [...this.element.children].forEach((card) => {
      const height = card.getBoundingClientRect().height;
      card.style.gridRowEnd = `span ${Math.ceil((height + GAP) / ROW)}`;
    });
  }
}
